<section class="review-and-pay" data-testid="review-and-pay" [attr.inert]="pageInert() ? '' : null">
  <app-shipment-stepper [activeStepIndex]="activeStepIndex" />

  @if (showPageSkeleton()) {
    <div class="review-and-pay__content" aria-busy="true">
      <app-review-and-pay-skeleton />
    </div>
  } @else {
    <div class="review-and-pay__content">
      <header class="review-and-pay__header">
        <puro-typography component="h2" variant="h2" class="review-and-pay__title">
          {{ 'createShipment.reviewAndPay.title' | translate }}
        </puro-typography>
        <puro-typography component="p" variant="body2" class="review-and-pay__required">
          {{ 'createShipment.reviewAndPay.requiredLegend' | translate }}
        </puro-typography>
      </header>

      <app-alert-toast
        severity="warning"
        [message]="'createShipment.reviewAndPay.costChangeWarning' | translate"
        [tooltipContent]="'createShipment.reviewAndPay.terms.quote' | translate"
        [tooltipAriaLabel]="'createShipment.reviewAndPay.costChangeWarningTooltipAria' | translate"
      />

      <puro-typography component="p" variant="body1" class="review-and-pay__instruction">
        {{ 'createShipment.reviewAndPay.instruction' | translate }}
      </puro-typography>

      <div class="review-and-pay__cards">
        <div class="review-and-pay__card-row">
          <app-review-address-summary
            kind="shipFrom"
            [address]="summaryViews().shipFromView"
            (editRequested)="onEditRequested($event)"
          />
          <app-review-address-summary
            kind="shipTo"
            [address]="summaryViews().shipToView"
            (editRequested)="onEditRequested($event)"
          />
          <app-review-address-summary
            kind="returnTo"
            [returnAddress]="summaryViews().returnView"
            (editRequested)="onEditRequested($event)"
          />
        </div>
        <div class="review-and-pay__card-row">
          <app-review-packaging-summary
            [view]="summaryViews().packagingView"
            (editRequested)="onEditRequested($event)"
          />
          <app-review-additional-services-summary
            [view]="summaryViews().additionalServicesView"
            (editRequested)="onEditRequested($event)"
          />
          <app-review-induction-summary
            [view]="summaryViews().inductionView"
            [locatorUrl]="summaryViews().dropOffLocatorUrl"
            (editRequested)="onEditRequested($event)"
          />
        </div>
      </div>

      <app-review-estimate-details
        [selectedService]="summaryViews().selectedService"
        [breakdown]="summaryViews().breakdown"
        [couponControl]="couponControl"
        [couponStatus]="couponStatus()"
        (applied)="onCouponApplied($event)"
      />

      <app-review-terms
        [accepted]="termsAccepted"
        [agreementError]="termsAgreementError()"
        (termsLinkClicked)="onTermsLinkClicked()"
      />

      <app-review-and-pay-actions
        [checkoutActive]="checkoutActive()"
        (backRequested)="onBackRequested()"
        (cancelRequested)="onCancelShipmentRequested()"
        (proceed)="onProceedToPayment()"
      />
    </div>
  }
</section>

<app-review-edit-warning-dialog
  [open]="editWarningOpen()"
  (cancelled)="onEditCancelled()"
  (confirmed)="onEditConfirmed()"
/>

<app-review-cancel-shipment-dialog
  [open]="cancelShipmentDialogOpen()"
  (dismissed)="onCancelShipmentDismissed()"
  (confirmed)="onCancelShipmentConfirmed()"
/>

<app-review-terms-dialog
  [open]="termsDialogOpen()"
  [termsAccepted]="termsAccepted"
  (agreed)="onTermsAgreed()"
  (disagreed)="onTermsDisagreed()"
/>

@if (paymentModalOpen()) {
  <app-review-payment-modal
    [open]="true"
    [processing]="paymentProcessing()"
    (closed)="onPaymentModalClosed()"
  />
}

@if (denyOpen()) {
  <app-review-payment-notice-dialog
    [open]="true"
    [titleKey]="denyTitleKey()"
    actionLabelKey="createShipment.reviewAndPay.paymentDeny.back"
    [message]="denyMessage()"
    messageTestId="payment-deny-message"
    (dismissed)="onDenyDismissed()"
  />
}

@if (timeoutOpen()) {
  <app-review-payment-notice-dialog
    [open]="true"
    titleKey="createShipment.reviewAndPay.paymentTimeout.title"
    actionLabelKey="createShipment.reviewAndPay.paymentTimeout.ok"
    bodyKey="createShipment.reviewAndPay.paymentTimeout.body"
    (dismissed)="onTimeoutDismissed()"
  />
}
